import { Calendar, Clock } from 'lucide-react';

interface DateTimeLabelProps {
  isoDatetime: string;
  timeZone: string;
}

export function DateTimeLabel({ isoDatetime, timeZone }: DateTimeLabelProps) {
  const date = new Date(isoDatetime);

  const datePart = new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);

  const timePart = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(date);

  return (
    <time
      dateTime={isoDatetime}
      className="flex flex-wrap items-center gap-x-3 gap-y-1 text-data-card-xs text-muted-foreground font-semibold"
    >
      <span className="flex items-center gap-1">
        <Calendar className="size-[1em] shrink-0" aria-hidden />
        {datePart}
      </span>
      <span className="flex items-center gap-1">
        <Clock className="size-[1em] shrink-0" aria-hidden />
        {timePart}
      </span>
    </time>
  );
}
